module.exports = __webpack_public_path__ + "img/angel-3.1b125497.jpg";